import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4dd571ec")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_t = _resolveComponent("t")
  const _component_DialogTemplate = _resolveComponent("DialogTemplate")

  return (_openBlock(), _createBlock(_component_DialogTemplate, null, {
    title: _withId(() => [
      _createVNode("div", null, _toDisplayString(_ctx.title), 1)
    ]),
    controls: _withId(() => [
      _createVNode("button", {
        class: "flex-1 btn primary mr-30",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
      }, [
        _createVNode(_component_t, {
          path: "credit_16",
          custom: ""
        }, {
          default: _withId(({td}) => [
            _createTextVNode(_toDisplayString(td || 'Got it'), 1)
          ]),
          _: 1
        })
      ])
    ]),
    default: _withId(() => [
      _createVNode("div", {
        class: "flex-1 pt-20 pr-20 credit_rule_text",
        innerHTML: _ctx.content
      }, null, 8, ["innerHTML"])
    ]),
    _: 1
  }))
})